import {Component} from '@angular/core';

@Component({
    selector: 'kan-contract',
    templateUrl: './component.html',
    styleUrls: ['./component.scss']
})
export class kanLoading {

    constructor() {
    }
}



// WEBPACK FOOTER //
// ./src/modules/services/components/loading/component.ts